
<mat-card style="box-shadow:none;    padding: 0px !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
        <span mat-card-avatar>
        <mat-icon>list</mat-icon>
        </span>
        <mat-card-title>Tour Escalation</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
<mat-dialog-content>
    <div>
        <div>
            <mat-form-field class="pds" style="padding-left: 2px; padding-right: 13%; padding-top: 20px;">
                <mat-label style="font-size: 15px !important;">Amco Id</mat-label>
                <input matInput [disabled]="true" [(ngModel)]="amcoId">
            </mat-form-field>

            <mat-form-field class="pde">
                <mat-label style="font-size: 15px !important;">Status</mat-label>
                <input matInput [disabled]="true" [(ngModel)]="status">
            </mat-form-field>

            <mat-form-field class="pde">
                <mat-label style="font-size: 15px !important;">Priority</mat-label>
                <mat-select
                    [(ngModel)]="typeId"
                    (selectionChange)="ngOnChanges()"
                >
                    <mat-option *ngFor="let option of typesList" [value]="option.id">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field style="width: 400px;">
                <mat-label style="padding:10px;">Topic</mat-label>
                <textarea class="textinputupdate" matInput [(ngModel)]="topic"></textarea>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field style="width: 400px;">
                <mat-label style="padding:10px;">Message</mat-label>
                <textarea class="textinputupdate" matInput [(ngModel)]="message"></textarea>
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
<button style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #bf1e2e;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 50px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="onCancelClick()">Cancel</button>

<button style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #bf1e2e;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 65px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="addClick()">Escalate</button>
</mat-dialog-actions>
</mat-card>

